// src/app/pages/dashboard/Apps/AmazonMAPViolationsWrapper.tsx

import React, {useState, useEffect, FC, useRef} from 'react'
import {PageTitle} from '../../../../_designereyes/layout/core'
import {API_URL} from '../../../modules/auth/core/_requests'
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
// import 'primereact/resources/themes/saga-blue/theme.css' // Theme
// import 'primereact/resources/primereact.min.css' // Core CSS
// import 'primeicons/primeicons.css' // Icons
import { Button } from 'primereact/button';
import { Card } from 'primereact/card';
import { Dialog } from 'primereact/dialog';
import 'animate.css'
import './MAPPriceRebateAnalysisWrapper.css'


interface MAPPriceData {
  sku_1: string;
  upc: string;
  model: string;
  brand: string;
  weighted_avg_cost: number;
  fifo_avg_cost: number;
  total_inventory_cost: number;
  total_quantity_cost: number;
  estimated_rebate: number;
}



interface InvoiceData {
  sku_1: string;
  Document_No_?: string;
  Order_No_?: string;
  Posting_Date?: string;
  Quantity?: number;
  Unit_Cost?: number;
  Amount?: number;
  Customer_No?: string;
}


interface ViewInvoiceAPIResponse {
  success: boolean;
  data?: InvoiceData[];
  error?: string;
}



const MAPPriceRebateAnalysisPage: FC = () => {
  const [data, setData] = useState<MAPPriceData[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [searchText, setSearchText] = useState('')
  const [searchType, setSearchType] = useState('none')
  const [isDownloadingExcel, setIsDownloadingExcel] = useState(false);
  const [isDownloadingInvoiceLog, setIsDownloadingInvoiceLog] = useState(false);
  const [selectedItems, setSelectedItems] = useState<MAPPriceData[]>([]);
  const [showInvoices, setShowInvoices] = useState(false);
  const [selectedInvoices, setSelectedInvoices] = useState<any>(null);
  const [first, setFirst] = useState<number>(0);
  const [rows, setRows] = useState<number>(10);
  const [invoiceData, setInvoiceData] = useState<InvoiceData[]>([]);
  const [loadingInvoices, setLoadingInvoices] = useState(false);




  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        const response = await fetch('http://localhost:4000/api/map-prices');
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        const jsonData = await response.json();
        // Extract the data array from the response
        setData(jsonData.data || []);
      } catch (error) {
        console.error('Error fetching MAP prices:', error);
        setData([]);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const handleSearch = async () => {
    setSelectedItems([]); // Clear selection when search button is clicked
    setLoading(true);
    try {
      // If search type is 'none' OR (search type is not 'none' but searchText is empty)
      if (searchType === 'none' || (searchType !== 'none' && !searchText.trim())) {
        const response = await fetch('http://localhost:4000/api/map-prices');
        const jsonData = await response.json();
        setData(jsonData.data || []);
        return;
      }
  
      // Make the search request
      const response = await fetch(
        `http://localhost:4000/api/map-prices/search?searchType=${searchType}&searchText=${encodeURI(searchText)}`
      );
      
      if (!response.ok) {
        throw new Error('Search request failed');
      }
      
      const jsonData = await response.json();
      setData(jsonData.data || []);
    } catch (error) {
      console.error('Error fetching MAP prices:', error);
      setData([]);
    } finally {
      setLoading(false);
    }
  };

  const handleDownloadExcel = async (data: MAPPriceData | MAPPriceData[]) => {
    try {
      setIsDownloadingExcel(true);
      const skus = Array.isArray(data) 

        ? data.map(item => item.sku_1)
        : [data.sku_1];
  
      const response = await fetch('http://localhost:4000/api/map-prices/download-excel', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ skus }),
      });
  
      if (!response.ok) {
        throw new Error('Failed to download Excel');
      }
  
      // Handle the Excel file download
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `map_prices_${new Date().toISOString().split('T')[0]}.xlsx`;
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
      document.body.removeChild(a);
    } catch (error) {
      console.error('Error downloading Excel:', error);
      // Add error notification here if you have a notification system
    } finally {
      setIsDownloadingExcel(false);
    }
  };
  
  const handleDownloadInvoiceLog = async (data: MAPPriceData | MAPPriceData[]) => {
    try {
      setIsDownloadingInvoiceLog(true);
      const skus = Array.isArray(data) 
        ? data.map(item => item.sku_1)
        : [data.sku_1];

  
      const response = await fetch('http://localhost:4000/api/map-prices/download-invoice-logs', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ skus }),
      });


  
      if (!response.ok) {
        throw new Error('Failed to download logs');
      }
  
      // Handle the file download
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = skus.length === 1 
        ? `log_${skus[0]}.log`
        : `logs_${new Date().toISOString().split('T')[0]}.zip`;

      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);
      document.body.removeChild(a);
    } catch (error) {
      console.error('Error downloading logs:', error);
      // Add error notification here if you have a notification system
    } finally {
      setIsDownloadingInvoiceLog(false);
    }
  };
  


  // Update the handleViewInvoices function
  const handleViewInvoices = async (rowData: MAPPriceData | MAPPriceData[]) => {
    // If rowData is a single item, wrap it in an array
    const selectedData = Array.isArray(rowData) ? rowData : [rowData];
    setSelectedInvoices(selectedData);
    setShowInvoices(true);
    
    try {
      setLoadingInvoices(true);
      const skus = selectedData.map(item => item.sku_1);
      
      const response = await fetch('http://localhost:4000/api/map-prices/invoices', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ skus }),
      });
  
      if (!response.ok) {
        throw new Error('Failed to fetch invoice data');
      }
  
      const result: ViewInvoiceAPIResponse = await response.json();
      if (result.success && result.data) {
        setInvoiceData(result.data);
      } else {
        setInvoiceData([]);
      }
    } catch (error) {
      console.error('Error fetching invoice data:', error);
      setInvoiceData([]);
    } finally {
      setLoadingInvoices(false);
    }
  };

  // Add this before the return statement
  const invoiceBodyTemplate = (rowData: MAPPriceData) => {
    return (
      <div className="d-flex justify-content-center">
        <Button
          icon="pi pi-eye"
          className="p-button-rounded p-button-text"
          onClick={() => handleViewInvoices(rowData)}
          tooltip="View Invoices"
        />
      </div>
    );
  };
  

return (
  <div className="card map-price-table">
    <Card className='mb-3 shadow-sm'>
        <div className='container-fluid'>
          {/* Top section with radio buttons and download buttons */}
          <div className='mb-3 d-flex justify-content-between align-items-center'>
            {/* Left side - Radio buttons */}
            <div className='d-flex gap-4'>
              <div className="custom-control custom-radio">
                <input
                  type="radio"
                  id="radioNone"
                  name="searchType"
                  className="custom-control-input"
                  checked={searchType === 'none'}
                  onChange={() => setSearchType('none')}
                />
                <label className="custom-control-label ms-2" htmlFor="radioNone">
                  All Products
                </label>
              </div>
              <div className="custom-control custom-radio">
                <input
                  type="radio"
                  id="radioBrand"
                  name="searchType"
                  className="custom-control-input"
                  checked={searchType === 'brand'}
                  onChange={() => setSearchType('brand')}
                />
                <label className="custom-control-label ms-2" htmlFor="radioBrand">
                  By Brand
                </label>
              </div>
              <div className="custom-control custom-radio">
                <input
                  type="radio"
                  id="radioModel"
                  name="searchType"
                  className="custom-control-input"
                  checked={searchType === 'model'}
                  onChange={() => setSearchType('model')}
                />
                <label className="custom-control-label ms-2" htmlFor="radioModel">
                  By Model
                </label>
              </div>
              <div className="custom-control custom-radio">
                <input
                  type="radio"
                  id="radioUPC"
                  name="searchType"
                  className="custom-control-input"
                  checked={searchType === 'upc'}
                  onChange={() => setSearchType('upc')}
                />
                <label className="custom-control-label ms-2" htmlFor="radioUPC">
                  By UPC
                </label>
              </div>
              <div className="custom-control custom-radio">
                  <input
                    type="radio"
                    id="radioSKU1"
                    name="searchType"
                    className="custom-control-input"
                    checked={searchType === 'sku_1'}
                    onChange={() => setSearchType('sku_1')}
                  />
                  <label className="custom-control-label ms-2" htmlFor="radioSKU1">
                    By SKU_1
                  </label>
                </div>
            </div>
            {/* Right side - Download buttons */}
            <div className='d-flex gap-2'>
            <Button
              label="View Invoices"
              icon="pi pi-eye"
              className="p-button-info"
              disabled={selectedItems.length === 0}
              onClick={() => {
                handleViewInvoices(selectedItems);
              }}
            />
            <Button
              label={isDownloadingExcel ? "Downloading..." : "Download Excel"}
              icon="pi pi-file-excel"
              className="p-button-success"
              disabled={selectedItems.length === 0 || isDownloadingExcel}
              loading={isDownloadingExcel}
              onClick={() => handleDownloadExcel(selectedItems)}
            />
            <Button 
              label={isDownloadingInvoiceLog ? "Downloading..." : "Download Invoice Log"}
              icon="pi pi-download"
              className="p-button-primary"
              disabled={selectedItems.length === 0 || isDownloadingInvoiceLog}
              loading={isDownloadingInvoiceLog}
              onClick={() => handleDownloadInvoiceLog(selectedItems)}
            />

            </div>
          </div>

          {/* Bottom section with search input and button */}
          <div className='row g-3'>
            <div className='col-md-9'>
              <input
                type='text'
                className='form-control'
                placeholder={`Search by ${searchType === 'none' ? 'all fields' : searchType}...`}
                value={searchText}
                onChange={(e) => setSearchText(e.target.value)}
                style={{height: '45px'}}
              />
            </div>
            <div className='col-md-3'>
              <Button
                label='Update Search'
                icon='pi pi-search'
                className='w-100'
                style={{height: '45px'}}
                onClick={handleSearch}
              />
            </div>
          </div>
        </div>
      </Card>
      <div className='card-body'>
        <h2 className='mb-3'>MAP Price Table</h2>
          <DataTable
          value={data}
          selection={selectedItems}
          onSelectionChange={(e) => setSelectedItems(e.value)}
          selectionMode="multiple"
          dataKey="direct_cost_id"
          loading={loading}
          showGridlines
          rows={rows}
          first={first}
          onPage={(e) => setFirst(e.first)}
          paginator
          filterDisplay="menu"
          removableSort
        >
          <Column 
            selectionMode="multiple"
            headerStyle={{ width: '3rem' }}
          />
          <Column 
            field="upc" 
            header="UPC" 
            sortable
            filter 
            filterPlaceholder="Search UPC"
          />
          <Column 
            field="model" 
            header="Model" 
            sortable
            filter
            filterPlaceholder="Search Model"
          />
          <Column 
            field="brand" 
            header="Brand" 
            sortable
            filter
            filterPlaceholder="Search Brand"
          />
          <Column 
            field="weighted_avg_cost" 
            header="Weighted Average Cost" 
            body={(rowData) => `$${(rowData.weighted_avg_cost || 0).toFixed(2)}`}
            sortable
            filter
            filterPlaceholder="Search Average Cost"
            dataType="numeric"
          />
          <Column 
            field="fifo_avg_cost" 
            header="FIFO Average Cost" 
            body={(rowData) => `$${(rowData.fifo_avg_cost || 0).toFixed(2)}`}
            sortable
            filter
            filterPlaceholder="Search FIFO Average"
            dataType="numeric"
          />
          <Column 
            field="total_inventory_cost" 
            header="Total Inventory Cost" 
            body={(rowData) => `$${(rowData.total_inventory_cost || 0).toFixed(2)}`}
            sortable
            filter
            filterPlaceholder="Search Inventory Cost"
            dataType="numeric"
          />
          <Column 
            field="total_quantity_cost" 
            header="Total Quantity Cost" 
            body={(rowData) => `$${(rowData.total_quantity_cost || 0).toFixed(2)}`}
            sortable
            filter
            filterPlaceholder="Search Quantity Cost"
            dataType="numeric"
          />
          <Column 
            field="estimated_rebate" 
            header="Estimated Rebate" 
            body={(rowData) => `$${(rowData.estimated_rebate || 0).toFixed(2)}`}
            sortable
            filter
            filterPlaceholder="Search Rebate"
            dataType="numeric"
          />
          <Column 
            header="Invoices" 
            body={invoiceBodyTemplate} 
            style={{ width: '12.5rem' }}
            alignHeader="center"
          />
        </DataTable>
        <Dialog 
          header="Invoices" 
          visible={showInvoices} 
          style={{ width: '50vw' }} 
          onHide={() => {
            setShowInvoices(false);
            setInvoiceData([]);
          }}
        >
          <div className="p-3">
            {loadingInvoices ? (
              <div className="text-center">
                <i className="pi pi-spin pi-spinner" style={{ fontSize: '2rem' }}></i>
                <p className="mt-2">Loading invoices...</p>
              </div>
            ) : Array.isArray(selectedInvoices) ? (
              // Multiple items selected
              <div>
                <h5>Invoices for {selectedInvoices.length} selected items</h5>
                {selectedInvoices.map((item) => (
                  <div key={item.sku_1} className="mb-4">
                    <h6 className="mb-2">UPC: {item.upc}</h6>
                    {invoiceData.filter(invoice => invoice.sku_1 === item.sku_1).length > 0 ? (
                      <div className="card p-0">
                        <DataTable 
                          value={invoiceData.filter(invoice => invoice.sku_1 === item.sku_1)}
                          showGridlines
                          size="small"
                          className="bordered-rows"
                          removableSort
                        >
                          <Column field="Document_No_" header="Document No" sortable />
                          <Column field="Order_No_" header="Order No" sortable />
                          <Column 
                            field="Posting_Date" 
                            header="Date"
                            sortable
                            dataType="date"
                            body={(rowData) => rowData.Posting_Date ? 
                              new Date(rowData.Posting_Date).toLocaleDateString() : 'N/A'}
                          />
                          <Column
                            field="Quantity"
                            header="Quantity"
                            sortable
                            dataType="numeric"
                            body={(rowData) => Number(rowData.Quantity).toFixed(1)}/>
                          <Column 
                            field="Unit_Cost" 
                            header="Unit Cost"
                            sortable
                            dataType="numeric"
                            body={(rowData) => `$${Number(rowData.Unit_Cost).toFixed(2)}`}
                          />
                          <Column 
                            field="Amount" 
                            header="Total Amount"
                            sortable
                            dataType="numeric"
                            body={(rowData) => `$${Number(rowData.Amount).toFixed(2)}`}
                          />
                        </DataTable>
                      </div>
                    ) : (
                      <div className="p-message p-message-info">
                        <i className="pi pi-info-circle p-message-icon"></i>
                        <span className="p-message-text">No invoices found for this UPC</span>
                      </div>
                    )}
                  </div>
                ))}
              </div>
            ) : (
              // Single item selected
              <div>
                <h5 className="mb-4">Invoices for UPC: {selectedInvoices?.upc}</h5>
                {invoiceData.filter(invoice => invoice.sku_1 === selectedInvoices.sku_1).length > 0 ? (
                  <div className="card p-0"> {/* Using PrimeReact card styling */}
                    <DataTable 
                      value={invoiceData.filter(invoice => invoice.sku_1 === selectedInvoices.sku_1)}
                      showGridlines
                      size="small"
                      className="bordered-rows"
                    >
                      <Column field="Document_No_" header="Document No" />
                      <Column field="Order_No_" header="Order No" />
                      <Column 
                        field="Posting_Date" 
                        header="Date"
                        body={(rowData) => rowData.Posting_Date ? 
                          new Date(rowData.Posting_Date).toLocaleDateString() : 'N/A'}
                      />
                      <Column field="Quantity" header="Quantity" />
                      <Column 
                        field="Unit_Cost" 
                        header="Unit Cost"
                        body={(rowData) => `$${Number(rowData.Unit_Cost).toFixed(2)}`}
                      />
                      <Column 
                        field="Amount" 
                        header="Total Amount"
                        body={(rowData) => `$${Number(rowData.Amount).toFixed(2)}`}
                      />
                    </DataTable>
                  </div>
                ) : (
                  <div className="p-message p-message-info">
                    <i className="pi pi-info-circle p-message-icon"></i>
                    <span className="p-message-text">No invoices found for this UPC</span>
                  </div>
                )}
              </div>
            )}
          </div>
            <div className="d-flex gap-4 mt-4">
              <Button
                    label="Download Excel"
                    icon="pi pi-file-excel"
                    className="p-button-success"
                    onClick={() => handleDownloadExcel(selectedInvoices)}
                    loading={isDownloadingExcel}
                    disabled={isDownloadingExcel}
              />
              <Button
                    label="Download Invoice Log"
                    icon="pi pi-download"
                    className="p-button-primary"
                    onClick={() => handleDownloadInvoiceLog(selectedInvoices)}
                    loading={isDownloadingInvoiceLog}
                    disabled={isDownloadingInvoiceLog}
                />
              </div>
        </Dialog>
      </div>
    <div className="mt-3 text" style={{marginLeft: '1.25rem'}}>
      {selectedItems.length > 0 ? (
        <span>{selectedItems.length} item{selectedItems.length === 1 ? '' : 's'} selected</span>
      ) : (
        <span>No items selected</span>
      )}
    </div>
  </div>
);
}


export const MAPPriceRebateAnalysisWrapper: FC = () => {
  return (
    <>
    <PageTitle>MAP Price Rebate Analysis</PageTitle>
      <MAPPriceRebateAnalysisPage />
    </>
  )
}